import { useResetRecoilState } from "recoil"
import Header from "../../components/common/Header"
import StepBox from "../../components/Signup/StepBox"
import signupStepState from "../../recoil/signupStep/atom"
import { useEffect } from "react"
import Footer from "../../components/common/Footer"
import SignupForm from "../../components/Signup/SignupForm"
import useScrollReset from "../../hooks/useScrollReset"
import styled from "styled-components"

const SignupPage = () => {
  const resetSignupStep = useResetRecoilState(signupStepState)

  useEffect(() => {
    resetSignupStep()
  }, [resetSignupStep])
  useScrollReset()

  return (
    <SignupPageContainer>
      <Header />
      <SignupContent>
        <StepBox />
        <SignupForm />
      </SignupContent>
      <Footer />
    </SignupPageContainer>
  )
}

export default SignupPage

const SignupPageContainer = styled.div`
  height: 100vh;
`

const SignupContent = styled.div`
  padding-top: 60px;
`
